import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import user from './user'
import shoppingCart from './shopping-cart'
import unreadNotification from '@/store/notification'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    user,
    shoppingCart,
    unreadNotification
  },
  strict: process.env.DEV
})
